import PropTypes from "prop-types";

const Radio = (props) => {
  const { onChange, value, name = "", checked, disabled, onClick } = props;
  return (
    <input
      disabled={disabled}
      className="form-radio h-5 w-5"
      type="radio"
      name={name}
      value={value}
      onChange={onChange || null}
      checked={checked}
      onClick={onClick}
    />
  );
};

Radio.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

export default Radio;
